import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const familyDetailService = {
  fetchFamilyDetailByCandidateID: (id) => {
    return axiosInstance.get(
      `/itl_familydetails?$select=_itl_candidateid_value,itl_name,itl_profession,itl_relation&$filter=_itl_candidateid_value eq ${id}`,
      {
        headers: headers,
      }
    );
  },

  addFamilyDetail: (obj) => {
    return axiosInstance.post(`/itl_familydetails`, obj, {
      headers: headers,
    });
  },

  updateFamilyDetail: (id, obj) => {
    return axiosInstance.patch(`/itl_familydetails(${id})`, obj, {
      headers: headers,
    });
  },

  deleteFamilyDetail: (id) => {
    return axiosInstance.delete(`/itl_familydetails(${id})`, {
      headers: headers,
    });
  },
};

export default familyDetailService;
